var n=function(t){return t.ADMIN="admin",t.ATTENDANTS="attendants",t.SUPPORT="support",t.SEO="seo",t.USER="user",t.VIP="vip",t}({});export{n as UserRole};